import { Region } from '@kaizenplatform/hugot-entity';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  region: Region;
  messageId: string;
}

const RegionSpecificFormattedMessage: FC<Props> = ({ region, messageId }) => {
  return region === 'jp' ? <FormattedMessage id={messageId} /> : <FormattedMessage id={`us_${messageId}`} />;
};

export default RegionSpecificFormattedMessage;
